exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#resume-table{text-align:center;margin:20px auto 50px;color:#646464}#resume-table,#resume-table table{border-collapse:collapse;width:100%}#resume-table table{max-width:900px;margin-left:auto;margin-right:auto}#resume-table th,td{text-align:center}#resume-table th{background-color:#e6e4e4;font-size:14px;height:40px}#resume-table td{width:25%;font-size:13px;border:1.5px solid #d8d8d8;border-collapse:collapse;padding:5px}#resume-table table #td-row:hover{background-color:#8eceec;color:#f7f7f7}.resume{max-width:960px;margin:20px auto 5px}.subtitle{font-size:13px;margin:10px;text-align:justify;color:#686868}#tabs_div{max-width:960px;margin-left:auto;margin-right:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-af0a646c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/resume/Resume.vue
// module id = 1096
// module chunks = 0